// Contact information
export const SUPPORT_PHONE_NUMBER = '(415) 617-9691';
export const SUPPORT_EMAIL_ADDRESS = 'orders@nibll.com';

export const NOREPLY_EMAIL_ADDRESS = 'no-reply@nibll.com';

// QUESTION: Should these be environment variables instead?
export const MARKETING_SITE_URL = 'https://www.nibll.com';
export const MARKETING_SITE_DOMAIN = 'nibll.com';

// Social links
export const SOCIAL_INSTAGRAM_URL = 'https://www.instagram.com/nibll.eats/';
export const SOCIAL_FACEBOOK_URL = 'https://www.facebook.com/nibll.eats/';
export const SOCIAL_LINKEDIN_URL = 'https://www.linkedin.com/company/nibll';

// Date/time
export const HOME_TIME_ZONE = 'America/New_York';
